/**
 * Aviso do momento marcado (esboço 3.3): "Momento marcado em 12:34" com "Desfazer", no alto do vídeo, por alguns
 * segundos. Fica dentro da sala (e não no toast do app) para aparecer também na janela flutuante, que é outro
 * documento. Se o servidor não conseguiu marcar, avisa no mesmo lugar.
 */
import { useEffect } from 'react';
import { Bookmark, TriangleAlert } from 'lucide-react';
import { useCallTranscript } from './transcriptContext';
import { timeLabel } from './transcriptProtocol';

export const NOTICE_MS = 6000;

/** @param {{ label: string, onUndo: () => void }} props */
export function MomentNoticeView({ label, onUndo }) {
    return (
        <div role="status" data-moment-notice="" className="flex items-center gap-3 rounded-full border border-amber-400/50 bg-black/80 py-1.5 pl-4 pr-2 text-sm text-white shadow-lg">
            <Bookmark className="h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" />
            <span>{`Momento marcado em ${label}`}</span>
            <button
                type="button"
                onClick={onUndo}
                className="rounded-full bg-white/15 px-3 py-1 text-xs font-semibold hover:bg-white/25 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
                Desfazer
            </button>
        </div>
    );
}

export function MomentNotice() {
    const transcript = useCallTranscript();
    const lastId = transcript?.lastMoment?.id ?? null;
    const error = transcript?.momentError ?? null;
    const dismiss = transcript?.dismissMomentNotice;

    useEffect(() => {
        if (!lastId && !error) return undefined;
        const timer = setTimeout(() => dismiss?.(), NOTICE_MS);
        return () => clearTimeout(timer);
    }, [lastId, error, dismiss]);

    if (!transcript || (!transcript.lastMoment && !error)) return null;
    return (
        <div className="pointer-events-none absolute inset-x-0 top-3 z-20 flex justify-center px-3">
            <div className="pointer-events-auto">
                {error ? (
                    <div role="alert" className="flex items-center gap-2 rounded-full border border-red-400/50 bg-black/80 px-4 py-1.5 text-sm text-white shadow-lg">
                        <TriangleAlert className="h-4 w-4 text-red-300" aria-hidden="true" />
                        {error}
                    </div>
                ) : (
                    <MomentNoticeView
                        label={timeLabel(transcript.lastMoment.at, transcript.origin)}
                        onUndo={() => transcript.undoMoment(transcript.lastMoment.id)}
                    />
                )}
            </div>
        </div>
    );
}
